// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-bar-style {
  height: 60px;
  background-color: #001489 !important;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  position: fixed;
  z-index: 1100;
  top: 0px;
  left: auto;
  right: 0px;
  color: inherit;
  border-bottom: 1px solid rgb(240, 240, 240);
}

.userIcon {
  position: absolute;
  right: -14px;
  height: 2rem;
}

.lang {
  cursor: pointer;
  margin-bottom: 5px;
}

.lang:hover {
  color: #0068b3;
}

.defLang {
  cursor: pointer;
  color: #ffcc00 !important;
  float: right;
  font-weight: bold;
  align-items: center;
  text-align: center;
  display: flex;
  position: relative;
}

.defLang:hover {
  color: #0068b3;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/header/Header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oCAAoC;EACpC,6DAA6D;EAC7D,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,aAAa;EACb,QAAQ;EACR,UAAU;EACV,UAAU;EACV,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".app-bar-style {\n  height: 60px;\n  background-color: #001489 !important;\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  box-shadow: none;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  position: fixed;\n  z-index: 1100;\n  top: 0px;\n  left: auto;\n  right: 0px;\n  color: inherit;\n  border-bottom: 1px solid rgb(240, 240, 240);\n}\n\n.userIcon {\n  position: absolute;\n  right: -14px;\n  height: 2rem;\n}\n\n.lang {\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.lang:hover {\n  color: #0068b3;\n}\n\n.defLang {\n  cursor: pointer;\n  color: #ffcc00 !important;\n  float: right;\n  font-weight: bold;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  position: relative;\n}\n\n.defLang:hover {\n  color: #0068b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
